import './Cart.css'
import CartItem from '../CartItem/CartItem'
import Paypal from '../Paypal/Paypal'
import { useSelector } from 'react-redux'
import { selectCart } from './cartSlice'
import {  Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const SHIPPING_MAX = 17

export default function Cart (  ) {
    const cartItems = useSelector(selectCart)
    // console.log('cart =>', cartItems)
    const [ shippingState, setShippingState ] = useState({
        pref: "",
        shipping: ""
    })
    const [ totalState, setTotalState ] = useState("")
    const [ subtotalState, setSubtotalState ] = useState("")


    const promoCode = ""

    const getSubtotal = (cartItems) => {
        let subtotal = 0
        for ( let i = 0 ; i < cartItems.length ; i++ ) {
            const quantity = Number(cartItems[i].quantity)
            const price = Number(cartItems[i].price)
            subtotal += (price * quantity)
        }
        if ( subtotal !== subtotalState ) {
            setSubtotalState( subtotal )
        }
        return subtotal
    }



    const getShipping = (cartItems) => {
        let shippingTotal = 0
        for ( let i = 0 ; i < cartItems.length ; i++ ) {
            const shipping = Number(cartItems[i].shipping)
            shippingTotal += shipping
        }
        if( shippingTotal > SHIPPING_MAX ) {
            shippingTotal = SHIPPING_MAX
        }
        if(shippingTotal === 0 && shippingState.pref !== 'NO_SHIPPING') {
            setShippingState( prev => {
                return{
                    ...prev,
                    pref: 'NO_SHIPPING'
                }
            })
        } else if (shippingTotal && shippingState.pref !== 'GET_FROM_FILE') {
            setShippingState( prev => {
                return{
                    ...prev,
                    pref: 'GET_FROM_FILE'
                }
            })
        }
        if( shippingState.shipping !== shippingTotal ) {
            setShippingState( prev => {
                return{
                    ...prev,
                    shipping: shippingTotal
                }
            })
        }
        return shippingTotal
    }

    const getDiscount = (promoCode) => {
        const discount = Number(promoCode)
        return discount
    }

    const getTotal = (subtotal, shipping, discount) => {
        const total = subtotal * (( 100 - discount ) /100 ) + shipping
        if ( total !== totalState ) {
            setTotalState( total )
        }
        return total
    }

    const subtotal = getSubtotal(cartItems)
    const shipping = getShipping(cartItems)
    const discount = getDiscount(promoCode)
    const total = getTotal(subtotal, shipping, discount)
    
    const isCartEmpty = () => {
        if ( cartItems.length < 1 ) {
            console.log("Cart is empty")
            return (
                <div id="empty-cart">
                    <h4>Your cart is empty</h4>
                    <Link className="continue-shopping btn btn-secondary" to="../shop">Continue Shopping</Link>
                </div>
            )
        }
        console.log("Cart is not empty")
        return (

            <div id="total-paypal">
                <div id="total-container">
                    <div><h4>Subtotal</h4><h4>${ subtotal }</h4></div>
                    <div><h4>Shipping</h4><h4>${ shipping }</h4></div>
                    { shipping > 0 ? <p>Because shipping costs have increased, we have had to raise our shipping price.</p> : null }
                    <div><h4>Total</h4><h4>${ total }</h4></div>

                </div>
                
                <Paypal  
                    shipping={ shippingState }
                    total={ totalState }
                    subtotal={ subtotalState }
                />
                <Link className="continue-shopping  btn btn-secondary" to="../shop">Continue Shopping</Link>

            </div>
        )
    }

    const handleGoBack = () => {
        window.history.go(-1);
    }

    console.log("cart Items", cartItems)
    return (
        <div id="cart">
            <div className="d-flex justify-content-start align-left"> {/* This will force its children to the left */}
                <button
                className="btn btn-link align-left"
                onClick={handleGoBack}
                >
                <FontAwesomeIcon icon={faArrowLeft} />
                <span className="ms-2">Go Back</span>
                </button>
            </div>
            <h1>Cart</h1>
            
            {
                cartItems.map(item => {
                    return <CartItem product={ item } />
                })
            }
            { isCartEmpty()}
            
            
        </div>
    )
}
